<template>
  <div class="disclaimer-bar">
    <i class="el-icon-warning-outline disclaimer-icon"></i>
    <template v-if="!isEditing">
      <span class="disclaimer-text">{{ content || '（尚無公告）' }}</span>
      <el-button
        v-if="isAdmin"
        class="disclaimer-btn"
        type="text"
        size="mini"
        icon="el-icon-edit"
        @click="handleEditting"
      >
        編輯
      </el-button>
    </template>
    <template v-else>
      <el-input
        v-model="tempContent"
        size="mini"
        class="disclaimer-input"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 4 }"
        maxlength="500"
      />
      <el-button
        class="disclaimer-btn save"
        type="primary"
        size="mini"
        :loading="isLoading"
        @click="handleSave"
      >
        儲存
      </el-button>
      <el-button class="disclaimer-btn" size="mini" :loading="isLoading" @click="handleClose">
        取消
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerBar',
  props: {
    content: { type: String, required: true },
    isAdmin: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      tempContent: '',
      isEditing: false,
    }
  },
  methods: {
    handleEditting() {
      this.tempContent = JSON.parse(JSON.stringify(this.content))
      this.isEditing = true
    },
    handleClose() {
      this.tempContent = ''
      this.isEditing = false
    },
    async handleSave() {
      this.content = JSON.parse(JSON.stringify(this.tempContent))
      await this.$emit('save', this.tempContent)
      this.isEditing = false
    },
  },
}
</script>

<style scoped lang="scss">
.disclaimer-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  background: #fdf6d3;
  border: 1px solid #f5e08a;
  border-left: 4px solid #e6a23c;
  color: #8a6d3b;
  padding: 8px 14px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
}
.disclaimer-icon {
  color: #e6a23c;
  font-size: 16px;
}
.disclaimer-text {
  flex: 1;
  white-space: pre-wrap;
  word-break: break-word;
  font-weight: 700;
}
.disclaimer-input {
  flex: 1;
  min-width: 200px;
}
.disclaimer-btn {
  color: #8a6d3b;
  &.save {
    color: #fff;
  }
}
</style>
